/* eslint-disable react/no-array-index-key */
import { classnames } from 'tailwindcss-classnames';
import Container from 'components/helpers/Container';

const ReactTabsSkeleton = () => {
  return (
    <Container size="standard" dataComponent="react/general/tabs">
      <div className={classnames('mt-[25px]', 'lg:min-h-[430px]')}>
        {/* Desktop skeleton - hidden on mobile */}
        <div className={classnames('hidden', 'lg:block')}>
          {/* Tab navigation skeleton */}
          <div className="border-gray-200 mb-6 flex border-b">
            {Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="bg-gray-200 mr-4 h-12 w-32 animate-pulse rounded-t-md" />
            ))}
          </div>
          {/* Tab content skeleton */}
          <div className="space-y-4">
            <div className="bg-gray-200 h-6 w-3/4 animate-pulse rounded" />
            <div className="bg-gray-200 h-4 w-full animate-pulse rounded" />
            <div className="bg-gray-200 h-4 w-5/6 animate-pulse rounded" />
            <div className="bg-gray-200 h-4 w-4/5 animate-pulse rounded" />
          </div>
        </div>

        {/* Mobile skeleton - hidden on desktop */}
        <div className={classnames('block', 'lg:hidden', 'space-y-4')}>
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="border-gray-200 rounded-lg border">
              {/* Mobile tab header skeleton */}
              <div className="border-gray-200 border-b p-4">
                <div className="bg-gray-200 h-5 w-1/2 animate-pulse rounded" />
              </div>
              {/* Mobile tab content skeleton */}
              <div className="space-y-3 p-4">
                <div className="bg-gray-200 h-4 w-full animate-pulse rounded" />
                <div className="bg-gray-200 h-4 w-3/4 animate-pulse rounded" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default ReactTabsSkeleton;
